import React, { createContext, useContext, useState } from "react";
import type { FormBannerType } from "../types/banner/banner.form";

type BannerFormContextType = {
  formBanner: FormBannerType;
  setFormBanner: React.Dispatch<React.SetStateAction<FormBannerType>>;
  resetForm: () => void;
};

const defaultBanner: FormBannerType = {
  title: "",
  image: null,
  categoryId: null,
  isActive: true,
  link: null,
  orientation: "horizontal",
  position: "home_top",
};

const BannerFormContext = createContext<BannerFormContextType | null>(null);

export const BannerFormProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [formBanner, setFormBanner] = useState<FormBannerType>(defaultBanner);
  const resetForm = () => {
    setFormBanner(defaultBanner);
  };
  return (
    <BannerFormContext.Provider
      value={{ formBanner, setFormBanner, resetForm }}
    >
      {children}
    </BannerFormContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useBannerForm = () => {
  const context = useContext(BannerFormContext);
  if (!context)
    throw new Error("useBannerForm must be used inside BannerFormProvider");
  return context;
};
